import _ from 'lodash'
import { Message } from 'element-ui'
import {
  isCommonTemplateCustomPage,
  isCommonTemplatePage,
  isCreativeTemplateCustomPage,
} from '@/views/creative/utils'
import ptTracker from '@pt/metrics-tracking/playturbo-collector'

function getPage(router) {
  const { name } = router
  // 素材仓库
  const whPages = {
    'creative.template': 'template',
    'creative.common-template': 'common-template',
    'creative.template.custom': 'custom',
    'creative.template.dco': 'dco',
  }
  // playturbo
  const ptPages = {
    'template.custom': 'custom',
    'template.dco': 'dco',
    'template.multi-custom': 'multi-custom',

    'common-template.custom': 'common-template-custom',
    'common-template.dco': 'common-template-dco',
    'common-template.multi-custom': 'common-template-multi-custom',
  }
  const pages = {
    ...whPages,
    ...ptPages,
  }

  console.log(`${name} 页面是`, pages[name])

  return pages[name]
}

export default function ({ state, commit }, { router }) {
  if (state.isReadonly) {
    Message({
      message: 'Read Only',
      type: 'error',
      duration: 5 * 1000,
    })
    return
  }

  const { templateId, customId, skinId } = router.params
  // const { sk}

  commit('updateRouter', router)
  // 优先使用 customId，有 customId 代表是制作页面
  commit('updatePageId', customId || templateId)
  // 模板 ID
  templateId && (state.templateId = Number(templateId))
  // 制作 ID
  customId && (state.customId = Number(customId))
  // 皮肤 ID
  skinId && (state.skinId = Number(skinId))

  // 预览基础包配置页面
  if (Number(_.get(router, 'query.preview')) === 1) {
    state.isPreviewBasicPackage = true

    const basicId = Number(_.get(router, 'query.basic_id'))
    if (!_.isUndefined(basicId)) {
      state.basicId = basicId
    } else {
      throw new Error('URL 上缺少基础包 ID')
    }
    const templateType = _.get(router, 'query.tpl_type')
    if (!_.isUndefined(templateType)) {
      state.templateType = templateType
    }
  }

  const page = getPage(router)
  // 更新页面信息
  commit('updatePage', page)
  state.isDco = false
  state.isTemplate = false
  state.isMultiCustom = false

  state.isCommonTemplateCustom = isCommonTemplateCustomPage(page)
  state.isCommonTemplatePage = isCommonTemplatePage(page)
  state.isCreativeTemplateCustom = isCreativeTemplateCustomPage(page)

  // 是否通用模板
  // 1. 通过url参数进入带templateType页面
  // 2. 使用通用模板制作的项目
  // 3. 模板编辑页
  state.isGeneralTemplateService =
    state.templateType === 'gm' ||
    state.isCommonTemplateCustom ||
    (state.isTemplate && state.isCommonTemplatePage)
  // 只有在 PT 上面才会有埋点上报，包含定制、通用制作和多组合制作
  if (state.isCommonTemplateCustom || state.isCreativeTemplateCustom) {
    ptTracker.startEvent({
      pid: customId,
      extra: {
        template_id: templateId,
        custom_id: customId,
        skin_id: skinId,
      },
    })
  }
}
